<script>
import Layout from "@layouts/main-fluid";

export default {
  page: {
    title: "Cadastros"
  },
  components: {
    Layout
  },
  methods: {
    onInput(value) {
      if (!this.visitedTabs.includes(value)) {
        this.visitedTabs.push(value);
      }
    }
  },
  data() {
    return {
      title: "Cadastros",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros",
          active: true
        }
      ],
      visitedTabs: [0]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <b-card no-body>
        <b-tabs card @input="onInput">
          <b-tab title="Contrato e Projeto" active>
            <b-card-text v-if="visitedTabs.includes(0)">
              <div class="row ml-2">
                <div class="col-md-6">                
                  <div class="mb-3">
                    <a href="/Projeto">Projeto</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Contrato">Contrato</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Cliente">Cliente</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Equipe">Equipe</a>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/Fatura">Fatura</a>
                  </div>
                  <div class="mb-3">
                    <a href="/dataFechamento">Data Fechamento</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ContratoAditivo">Contrato Aditivo</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ContratoRenovacao">Contrato Renovação</a>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Acesso">
            <b-card-text v-if="visitedTabs.includes(1)">
              <div class="row ml-2">
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/Cliente">Cliente</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Consultor">Consultor</a>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/Usuario">Usuário</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Perfil">Perfil</a>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Chamados">
            <b-card-text v-if="visitedTabs.includes(2)">
              <div class="row ml-2">
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/Chamado">Chamado</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ChamadoFluxoTransicao">Chamado Fluxo Transição</a>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/ChamadoPrioridade">Chamado Prioridade</a>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>

          <b-tab title="Parametrização">
            <b-card-text v-if="visitedTabs.includes(3)">
              <div class="row ml-2">
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/Parametro">Parâmetro</a>
                  </div>
                  <div class="mb-3">
                    <a href="/Feriado">Feriado</a>
                  </div>
                  <div class="mb-3">
                    <a href="/TabelaCalculo">Tabela de Cálculo</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ContratoDespesaTipo"
                      >Tipo de despesa de contrato</a
                    >
                  </div>
                  <div class="mb-3">
                    <a href="/ProjetoTipo">Tipo de Projeto</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ContratoTipo">Tipo de Contrato</a>
                  </div>
                  <div class="mb-3">
                    <a href="/TarefaStatus">Tarefa Status</a>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <a href="/ExpedienteTipo">Tipo de Expediente</a>
                  </div>
                  <div class="mb-3">
                    <a href="/ExpedienteLocal">Local de Expediente</a>
                  </div>
                  <div class="mb-3">
                    <a href="/TarefaPrioridade">Tarefa Prioridade</a>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </Layout>
</template>
